import { render, staticRenderFns } from "./distributionWorkBench.vue?vue&type=template&id=61749244&"
import script from "./distributionWorkBench.vue?vue&type=script&lang=js&"
export * from "./distributionWorkBench.vue?vue&type=script&lang=js&"
import style0 from "./distributionWorkBench.vue?vue&type=style&index=0&id=61749244&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports